// extracted by mini-css-extract-plugin
export default {"layout":"Account_layout__iSuW7","main":"Account_main__sCUm8"};